<template>
  <div class="header">
    <md-toolbar class="md-whiteframe main-header  md-whiteframe-1dp">
      <md-button class="md-icon-button" @click.native="toggleLeftSidenav">
        <md-icon>menu</md-icon>
      </md-button>
      <h2 class="md-title">{{title}}</h2>
      <md-layout md-hide-small>
        <img src="../assets/logo.png" class="logo">
      </md-layout>
    </md-toolbar>
    <md-sidenav :md-swipeable="true" class="md-left" ref="leftSidenav">

      <md-toolbar class="md-small">
        <div class="md-toolbar-container">
          <md-avatar class="avatar">
            <img :src="currentUser.photoURL" alt="Avatar">
          </md-avatar>
          <h3 class="md-title nickname"> {{ currentUser.displayName }} </h3>
        </div>
      </md-toolbar>

      <md-list v-if="currentFluxer[0]">

        <md-list-item>
          <router-link to="proceso"><md-icon>question_answer</md-icon> <span>Proceso de Feedback</span></router-link>
        </md-list-item>

        <md-list-item>
          <router-link to="/"><md-icon>assignment_turned_in</md-icon> <span>Feedback a Fluxers</span></router-link>
        </md-list-item>


        <md-list-item v-if="currentFluxer[0].lider">
          <router-link to="/acuerdo-objetivos"><md-icon>playlist_add_check</md-icon> <span>Acuerdo De Objetivos</span></router-link>
        </md-list-item>

        <md-list-item>
          <router-link to="/mis-objetivos"><md-icon>playlist_add_check</md-icon> <span>Mis Objetivos</span></router-link>
        </md-list-item>

        <md-list-item v-show="false">
          <router-link to="/mis-meritos"><md-icon> </md-icon> <span>Mis Meritos</span></router-link>
        </md-list-item>

        <md-list-item v-if="currentFluxer[0].admin" v-show="false">
          <router-link to="/admin-mis-meritos"><md-icon> </md-icon> <span>Administrar Mis Meritos</span></router-link>
        </md-list-item>

        <md-list-item v-if="currentFluxer[0].admin">
          <router-link to="/reporte-feedbacks"><md-icon>assessment</md-icon> <span>Reporte de Feedbacks</span></router-link>
        </md-list-item>

        <md-list-item v-if="currentFluxer[0].admin">
          <router-link to="/reporte-objetivos"><md-icon>assessment</md-icon> <span>Reporte de Objetivos</span></router-link>
        </md-list-item>

        <md-list-item>
          <router-link to="/logout"><md-icon>exit_to_app</md-icon> <span>Salir</span></router-link>
        </md-list-item>
      </md-list>

    </md-sidenav>
  </div>
</template>

<script>
  import FluxerService from '../services/fluxer'

  export default {
    name: 'header',
    props: ['title', 'currentUser'],
    firebase: function () {
      return {
        currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email)
      }
    },
    methods: {
      toggleLeftSidenav () {
        this.$refs.leftSidenav.toggle()
      }
    }
  }

</script>


<style scoped>

  .logo {
      width: 100px;
      right: 15px;
      position: fixed;
      opacity: 0.7;
      top: 12px
  }

  .header {
    position: fixed;
    width: 100%;
    z-index: 5;
  }

  .nickname {
    margin: auto !important;
  }

  .avatar {
    margin: 10px !important;
  }

</style>



// WEBPACK FOOTER //
// Header.vue?bb63d84c